// extracted by mini-css-extract-plugin
export var active = "_b0-7";
export var container = "_b0-0";
export var evenWidth = "_b0-4";
export var large = "_b0-5";
export var outlet = "_b0-8";
export var slide = "_b0-2";
export var small = "_b0-6";
export var tab = "_b0-3";
export var tabs = "_b0-1";